import React, { useEffect, useContext, useState } from "react";
import "../../assets/css/form.css";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { AppSettings } from "../../config/app-settings.js";
import {
  Panel,
  PanelBody,
  PanelHeader,
} from "../../components/panel/panel.jsx";
import { CatalogosService } from "../../services/catalogos.service.js";
import { PostulanteService } from "../../services/postulantes.service.js";
import { useReactToPrint } from "react-to-print";
import Print from "./Print.tsx";
import {
  getCandidateByApplication,
  updateApplicationForm,
  upgradeCollaborator,
  updateApplicationStatus,
} from "../../services/application.service.ts";
import { updateCandidate } from "../../services/candidate.service.ts";
import { notification } from "../../utils/Notifications.tsx";
import {
  findBranchesByVacancie,
  getVacancies,
} from "../../services/vacancy.service.ts";
import { getUnfilledPositionByBranch } from "../../services/partner.service.ts";
import { getSchoolings } from "../../services/schooling.service.ts";
import { getShifts } from "../../services/shift.service.ts";
import { readApplicationStatuses } from "../../services/applicationStatuses.service.ts";
import { readReason } from "../../services/reasons.service.ts";
import S3Service from "../../services/s3.service.ts";
import { getPeriodicities } from "../../services/periodicty.service.ts";
import { readBranches } from "../../services/branch.service.ts";
import { readSizes } from "../../services/size.service.ts";
import ModalContainer from "../../components/ModalContainer.tsx";
import DocUploadSlot from "../../components/result/DocUploadSlot.tsx";
import {
  resultFormStyles,
  getStatusBadgeStyle,
  ResultSection,
  ResultSectionHeader,
  ResultSectionBody,
  getControlStyle,
  getTextareaStyle,
  getStatusAccentColor,
  getWorkDayChipStyle,
  ResultFormUiStyles,
} from "../../components/result/applicationFormUi.js";
import UpgradeToCollaborator from "./UpgradeToCollaborator.tsx";
import ConfettiExplosion from "react-confetti-explosion";
import { toCamelCase } from "../../hooks/toCameCase.tsx";
import PositionUniformsInfo from "../../components/uniforms/PositionUniformsInfo.tsx";
import UniformPaymentForm from "../../components/uniforms/UniformPaymentForm.tsx";
import {
  createUniformPayment,
  updateUniformPaymentPartnerId,
} from "../../services/uniform-payment.service.ts";
import { ICreateUniformPayment } from "../../interfaces/IUniformPayment.ts";
import PositionDocumentsSelector from "../../components/documents/PositionDocumentsSelector.tsx";
import CandidateDocumentUploader from "../../components/documents/CandidateDocumentUploader.tsx";
import CandidateDocumentsViewer from "../../components/documents/CandidateDocumentsViewer.tsx";
import {
  createLeaderInterview,
  getLeaderInterviewByApplication,
} from "../../services/leader-availabilities.service.ts";
import moment from "moment";
import ScheduleLeaderInterview from "../../components/postulantes/ScheduleLeaderInterview.tsx";

function FormPostulante() {
  const navigate = useNavigate();
  const context = useContext(AppSettings);
  const location = useLocation();
  const isLeaderView = location.state?.isLeaderView ?? false;

  const componentRef = React.useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const [redirect, setRedirect] = useState(false);
  const [schoolings, setSchoolings] = useState([]);
  const [positions, setPositions] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [branches, setBranches] = useState([]);
  const [periodicities, setPeriodicities] = useState([]);
  const [interviewDate, setInterviewDate] = useState(new Date());
  const [candidate, setCandidate] = useState({});

  const [perfilUrl, setPerfilUrl] = useState(null);
  const [ineUrl, setIneUrl] = useState(null);
  const [ine1Url, setIne1Url] = useState(null);
  const [domicilioUrl, setDomicilioUrl] = useState(null);
  const [solicitudUrl, setSolicitudUrl] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [docPreviewModal, setDocPreviewModal] = useState({
    open: false,
    title: "",
    src: "",
  });

  const [isDisabled, setIsDisabled] = useState(
    location.state?.applicationStatus?.name !== "Solicitado"
  );

  const [isPrinting, setIsPrinting] = useState(false);
  const [selectedPositionId, setSelectedPositionId] = useState(null);
  const [uniformPayment, setUniformPayment] = useState(null);
  const [uniformsTotalAmount, setUniformsTotalAmount] = useState(0);
  const [isUpgrading, setIsUpgrading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const uploadDocumentsRef = React.useRef(null);
  const [selectedDays, setSelectedDays] = useState([]);

  const [interviewCheck, setInterviewCheck] = useState(false);
  const [selectedLeader, setSelectedLeader] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState("");
  const [leaderNotes, setLeaderNotes] = useState("");
  const [interviewData, setInterviewData] = useState(null);
  const [statusList, setStatusList] = useState([]);
  const [selectedBranchIdForPosition, setSelectedBranchIdForPosition] = useState(
    () => location.state?.candidate_id_branch ?? null
  );
  const [selectedShiftIdForPosition, setSelectedShiftIdForPosition] = useState(
    () => location.state?.candidate_id_shift ?? null
  );
  const [positionsFilteredByBranchShift, setPositionsFilteredByBranchShift] = useState([]);

  useEffect(() => {
    if (!selectedBranchIdForPosition || !selectedShiftIdForPosition) {
      setPositionsFilteredByBranchShift([]);
      return;
    }
    const shiftName = shifts.find((s) => Number(s.id) === Number(selectedShiftIdForPosition))?.name;
    if (!shiftName) {
      setPositionsFilteredByBranchShift([]);
      return;
    }
    getUnfilledPositionByBranch(Number(selectedBranchIdForPosition))
      .then((rows) => {
        const byShift = (rows || []).filter((row) => row.shift === shiftName);
        const uniqueByPositionId = [...new Map(byShift.map((p) => [p.position?.id, p])).values()].filter(
          (p) => p.position?.id
        );
        setPositionsFilteredByBranchShift(uniqueByPositionId);
      })
      .catch(() => setPositionsFilteredByBranchShift([]));
  }, [selectedBranchIdForPosition, selectedShiftIdForPosition, shifts]);

  useEffect(() => {
    readApplicationStatuses().then(setStatusList).catch(console.error);

    const statusName = location.state?.applicationStatus?.name;
    if (
      isLeaderView ||
      statusName === "Entrevista con Lider" ||
      statusName === "Pre-Colaborador"
    ) {
      getLeaderInterviewByApplication(location.state.id)
        .then((data) => {
          if (data) setInterviewData(data);
        })
        .catch(console.error);
    }
  }, []);

  useEffect(() => {
    if (location.state?.candidate_dias_trabajo) {
      const daysArray = location.state.candidate_dias_trabajo
        .split(",")
        .map((d) => parseInt(d.trim()))
        .filter((d) => !isNaN(d) && d >= 1 && d <= 7);
      setSelectedDays(daysArray);
    }

    if (
      location.state?.applicationStatus?.name === "Pre-Colaborador" ||
      location.state?.applicationStatus?.name === "Entrevista con Lider"
    ) {
      fetchCandidate();
    }

    dependecies();

    fetchImages();

    context.handleSetAppSidebarNone(true);
    context.handleSetAppHeaderNone(true);
    context.handleSetAppContentClass("p-4");
    context.handleSetAppTopMenu(true);

    return () => {
      context.handleSetAppSidebarNone(false);
      context.handleSetAppHeaderNone(false);
      context.handleSetAppContentClass("");
      context.handleSetAppTopMenu(false);
    };
  }, []);

  const handleGenerarOrden = (event) => {
    event.preventDefault();
    setIsPrinting(true);
    window.print();
  };

  const updateSucursal = async (event) => {
    console.log(event.target.value);
    try {
      const response = await findBranchesByVacancie(event.target.value);
      setBranches(response);
    } catch (error) {}
  };

  const handlePositionChange = (event) => {
    const positionId = Number(event.target.value);
    setSelectedPositionId(positionId);

    setUniformPayment(null);
    setSelectedDocuments([]);
  };

  const handleUniformPaymentChange = (payment) => {
    console.log("handleUniformPaymentChange called with:", payment);
    setUniformPayment(payment);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSaving(true);

    if (isLeaderView) {
      try {
        if (candidate?.id) {
          await updateCandidate(candidate.id, { leaderNotes });
        }

        const preColabStatus = statusList.find(
          (s) => s.name === "Pre-Colaborador"
        );
        if (preColabStatus) {
          await updateApplicationStatus(location.state.id, preColabStatus.id);
        } else {
          await updateApplicationStatus(location.state.id, 4);
          console.warn(
            "Status 'Pre-Colaborador' not found in list, using ID 4 fallback"
          );
        }

        notification(
          "Éxito",
          "Evaluación de Líder guardada correctamente",
          "success"
        );
        navigate("/leader-calendar");
      } catch (error) {
        console.error(error);
        notification("Error", "Error al guardar evaluación", "danger");
      } finally {
        setIsSaving(false);
      }
      return;
    }

    const getFormValue = (name) => {
      const el = event.target.elements ? event.target.elements[name] : null;
      return el ? el.value : null;
    };

    const body = {};
    body.positionId = Number(
      getFormValue("candidatePosition") || candidate?.vacancy?.position?.id || 0
    );
    body.periodicityId = Number(
      getFormValue("candidatePeriodicity") || candidate?.periodicity?.id || 0
    );
    body.branchId = Number(
      getFormValue("candidateBranch") || candidate?.branch?.id || 0
    );
    body.shiftId = Number(
      getFormValue("candidateShift") || candidate?.shift?.id || 0
    );
    body.sizeId = Number(
      getFormValue("candidateSize") || candidate?.size?.id || 0
    );
    body.recruitmentDate =
      getFormValue("candidateRecruitmentDate") ||
      candidate?.recruitmentDate ||
      "";
    body.monthlySalary = Number(
      getFormValue("candidateMonthlySalary") || candidate?.monthlySalary || 0
    );
    body.comments =
      getFormValue("candidateComments") || candidate?.comments || "";
    body.diasTrabajo =
      selectedDays.length > 0
        ? selectedDays.join(",")
        : candidate?.diasTrabajo || "";
    body.notasReclutador =
      getFormValue("candidateNotasReclutador") ||
      candidate?.notasReclutador ||
      "";

    try {
      if (
        location.state?.applicationStatus?.name === "Aceptado" &&
        interviewCheck
      ) {
        if (!selectedLeader || !selectedDate || !selectedSlot) {
          notification(
            "Atención",
            "Debe completar la agenda de entrevista con el líder",
            "warning"
          );
          setIsSaving(false);
          return;
        }

        await updateApplicationForm(location.state.id, body);

        await handleDocumentsAndUniforms();

        await PostulanteService.updateApplication(
          location.state.id,
          "complete_candidate_info",
          body
        );

        const [hour, minute] = selectedSlot.split(":").map(Number);
        const startTime = moment(selectedDate)
          .hour(hour)
          .minute(minute)
          .second(0);
        const endTime = startTime.clone().add(15, "minutes");

        await createLeaderInterview({
          leaderId: Number(selectedLeader),
          applicationId: Number(location.state.id),
          startTime: startTime.format(),
          endTime: endTime.format(),
        });

        const interviewStatus = statusList.find(
          (s) => s.name === "Entrevista con Lider"
        );
        if (interviewStatus) {
          await updateApplicationStatus(location.state.id, interviewStatus.id);
        } else {
          console.error("Status 'Entrevista con Lider' not found");

          notification(
            "Error",
            "No se encontró el estatus 'Entrevista con Lider'",
            "danger"
          );
        }

        notification(
          "Éxito",
          "Entrevista agendada y solicitud actualizada",
          "success"
        );
        setRedirect(true);
      } else {
        await updateApplicationForm(location.state.id, body);
        await handleDocumentsAndUniforms();

        let operation;
        if (location.state?.applicationStatus?.name == "Aceptado") {
          operation = "complete_candidate_info";
        }

        await PostulanteService.updateApplication(
          location.state.id,
          operation,
          body
        );

        if (
          location.state?.applicationStatus?.name === "Entrevista con Lider" &&
          !isLeaderView
        ) {
          if (candidate?.id) {
            await updateCandidate(candidate.id, {
              leaderNotes: "NO ENTREVISTADO (ADMINISTRADOR)",
            });
          }
          const preColabStatus = statusList.find(
            (s) => s.name === "Pre-Colaborador"
          );
          if (preColabStatus) {
            await updateApplicationStatus(location.state.id, preColabStatus.id);
          }
          notification(
            "Éxito",
            "Procesado sin entrevista con líder",
            "success"
          );
        }

        setRedirect(true);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      notification("Error", "Ocurrió un error al guardar", "danger");
    } finally {
      setIsSaving(false);
    }
  };

  const handleDocumentsAndUniforms = async () => {
    if (uploadDocumentsRef.current) {
      try {
        await uploadDocumentsRef.current();
      } catch (error) {
        notification(
          "Error",
          error.message || "Error al subir documentos",
          "danger"
        );
        throw error;
      }
    }

    if (uniformPayment && uniformPayment.mustPay) {
      try {
        const paymentData = {
          applicationId: location.state.id,
          mustPay: true,
          installments: uniformPayment.installments,
          totalAmount: uniformPayment.totalAmount,
          amountPerFortnight: uniformPayment.amountPerFortnight,
          totalUnitAmount: uniformPayment.totalUnitAmount,
          currentFortnight: uniformPayment.currentFortnight,
        };
        await createUniformPayment(paymentData);
      } catch (error) {
        console.error("Error creating uniform payment:", error);
      }
    }
  };

  const fetchCandidate = async () => {
    try {
      const response = await getCandidateByApplication(location.state.id);
      setCandidate(response);
      if (response?.leaderNotes) {
        setLeaderNotes(response.leaderNotes);
      }

      if (response?.vacancy?.position?.id) {
        setSelectedPositionId(response.vacancy.position.id);
        try {
          const branchesResponse = await findBranchesByVacancie(
            response.vacancy.position.id
          );
          setBranches(branchesResponse);
        } catch (error) {
          console.error(
            "Error loading branches for candidate position:",
            error
          );
        }
      }

      if (response?.diasTrabajo) {
        const daysArray = response.diasTrabajo
          .split(",")
          .map((d) => parseInt(d.trim()))
          .filter((d) => !isNaN(d) && d >= 1 && d <= 7);
        setSelectedDays(daysArray);
      } else {
        setSelectedDays([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const toggleDay = (dayNumber) => {
    setSelectedDays((prev) => {
      if (prev.includes(dayNumber)) {
        return prev.filter((d) => d !== dayNumber);
      } else {
        return [...prev, dayNumber].sort((a, b) => a - b);
      }
    });
  };

  const getDayName = (dayNumber) => {
    const days = [
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
      "Domingo",
    ];
    return days[dayNumber - 1] || "";
  };

  const selectWeekdays = () => {
    setSelectedDays([1, 2, 3, 4, 5]);
  };

  const selectWeekend = () => {
    setSelectedDays([6, 7]); // Sábado y Domingo
  };

  if (redirect) {
    return <Navigate to="/solicitudes" />;
  }

  const handleClick = async () => {
    setIsUpgrading(true);
    try {
      const response = await upgradeCollaborator(Number(location.state.id));
      console.log(response);
      notification("Listo ✅", response?.message, "success");

      // Actualizar partnerId en el pago de uniformes existente
      if (uniformPayment && uniformPayment.mustPay && response?.id) {
        try {
          console.log("Updating uniform payment partnerId:", {
            applicationId: location.state.id,
            partnerId: response.id,
          });
          await updateUniformPaymentPartnerId(location.state.id, response.id);
          console.log("Uniform payment partnerId updated successfully");
        } catch (error) {
          console.error("Error updating uniform payment partnerId:", error);
        }
      }

      setShowModal(false);
      navigate(`/colaboradores/detalles/${response?.id}`, {
        state: { confetti: true },
      });
      // navigate("/result/form", { state: { ...application, disabledForm } });
    } catch (error) {
      notification("Error", "Ah ocurrido un error", "danger");
    } finally {
      setIsUpgrading(false);
    }
  };

  const dependecies = async () => {
    try {
      const positions = await getVacancies();
      setPositions(positions);

      const schoolings = await getSchoolings();
      setSchoolings(schoolings);

      const shifts = await getShifts();
      setShifts(shifts);

      // const applicationStatuses = await readApplicationStatuses();
      // setApplicationStatuses(applicationStatuses);

      // const reasons = await readReason();
      // setRea(reasons);

      const periodicities = await getPeriodicities();
      setPeriodicities(periodicities);

      // const branchs = await readBranches();
      // setBranches(branchs);

      const sizes = await readSizes();
      setSizes(sizes);

      const allBranches = await readBranches();
      setBranches(Array.isArray(allBranches) ? allBranches.map((b) => ({ branch: b })) : []);
    } catch (error) {
      notification("Ocurrio un error!", error.message, "danger");
      console.log(error);
    }
  };

  const fetchImages = async () => {
    try {
      const profileUrl = await S3Service.getFile(
        "PERFIL_" + location.state.person.curp
      );
      setPerfilUrl(profileUrl.url);
      const ineUrl = await S3Service.getFile(
        "INE_" + location.state.person.curp
      );
      setIneUrl(ineUrl.url);
      const ine1Url = await S3Service.getFile(
        "INE_1_" + location.state.person.curp
      );
      setIne1Url(ine1Url.url);
      const domicilioUrl = await S3Service.getFile(
        "DOMICILIO_" + location.state.person.curp
      );
      setDomicilioUrl(domicilioUrl.url);
      const solicitudUrl = await S3Service.getFile(
        "SOLICITUD_" + location.state.person.curp
      );
      setSolicitudUrl(solicitudUrl.url);
    } catch (error) {
      console.log(error);
    }
  };

  const statusName = location.state?.applicationStatus?.name || "";
  const candidateName = toCamelCase(
    `${location.state.person.firstName} ${location.state.person.lastName}${
      location.state.person.secondLastName
        ? ` ${location.state.person.secondLastName}`
        : ""
    }`
  );

  const openDocPreview = (src, title) => {
    setDocPreviewModal({ open: true, src, title });
  };

  const statusAccent = getStatusAccentColor(statusName);
  const disabledFieldStyle = getControlStyle(true);
  const enabledFieldStyle = getControlStyle(false);

  return (
    <div style={resultFormStyles.page}>
      <div style={resultFormStyles.pageInner}>
        <header style={resultFormStyles.header}>
          <button
            type="button"
            aria-label="Regresar"
            style={resultFormStyles.backBtn}
            onClick={() => navigate(-1)}
          >
            <i className="fa fa-arrow-left" aria-hidden />
          </button>
          <div style={resultFormStyles.titleBlock}>
            <h1 style={resultFormStyles.title}>{candidateName}</h1>
            <p style={resultFormStyles.subtitle}>
              Solicitud #{location.state.id} · Detalle de postulante
            </p>
          </div>
          <span style={getStatusBadgeStyle(statusName)}>{statusName}</span>
        </header>

        <ResultFormUiStyles />
        <form
          onSubmit={handleSubmit}
          className="fs-13px result-form-ui result-form-stack"
          style={resultFormStyles.formStack}
        >
          <fieldset disabled={isLeaderView}>
            <ResultSection>
              <ResultSectionHeader statusName={statusName}>
                <span>Datos generales</span>
                <button
                  type="button"
                  style={resultFormStyles.historialChip}
                  onClick={() =>
                    navigate(
                      `/postulante/historial/${location.state.person.curp}`
                    )
                  }
                >
                  Revisar historial <i className="fa-solid fa-file" />
                </button>
              </ResultSectionHeader>
              <ResultSectionBody>
                <div
                  className="result-form-fields-row"
                  style={resultFormStyles.fieldsGridRow}
                >
                  <div style={resultFormStyles.fieldBlock}>
                    <label htmlFor="firstName" style={resultFormStyles.fieldLabel}>
                      Nombre(s) *
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="firstName"
                      name="firstName"
                      defaultValue={toCamelCase(location.state.person.firstName)}
                      disabled={isDisabled}
                      required
                      style={getControlStyle(isDisabled)}
                    />
                  </div>
                  <div style={resultFormStyles.fieldBlock}>
                    <label htmlFor="lastName" style={resultFormStyles.fieldLabel}>
                      Apellido paterno *
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="lastName"
                      name="lastName"
                      defaultValue={toCamelCase(location.state.person.lastName)}
                      disabled={isDisabled}
                      required
                      style={getControlStyle(isDisabled)}
                    />
                  </div>
                  <div style={resultFormStyles.fieldBlock}>
                    <label
                      htmlFor="secondLastName"
                      style={resultFormStyles.fieldLabel}
                    >
                      Apellido materno *
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="secondLastName"
                      name="secondLastName"
                      defaultValue={toCamelCase(
                        location.state.person.secondLastName
                      )}
                      disabled={isDisabled}
                      required
                      style={getControlStyle(isDisabled)}
                    />
                  </div>
                </div>
                <div
                  className="result-form-fields-row"
                  style={resultFormStyles.fieldsGridRow}
                >
                  <div style={resultFormStyles.fieldBlock}>
                    <label htmlFor="nacimiento" style={resultFormStyles.fieldLabel}>
                      Fecha de nacimiento
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="nacimiento"
                      name="nacimiento"
                      defaultValue={location.state.person.birthdate}
                      disabled={isDisabled}
                      style={getControlStyle(isDisabled)}
                    />
                  </div>
                  <div style={resultFormStyles.fieldBlock}>
                    <label htmlFor="phone" style={resultFormStyles.fieldLabel}>
                      Teléfono *
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="phone"
                      name="phone"
                      defaultValue={location.state.person.phone}
                      disabled={isDisabled}
                      required
                      style={getControlStyle(isDisabled)}
                    />
                  </div>
                  <div style={resultFormStyles.fieldBlock}>
                    <label htmlFor="schoolingId" style={resultFormStyles.fieldLabel}>
                      Escolaridad *
                    </label>
                    <select
                      className="form-select"
                      id="schoolingId"
                      name="schoolingId"
                      disabled={isDisabled}
                      required
                      style={getControlStyle(isDisabled)}
                      defaultValue={location.state.person?.schooling?.name || ""}
                    >
                      {schoolings.map((item) => (
                        <option key={item.id} value={item.name}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div style={resultFormStyles.fieldBlock}>
                  <label htmlFor="direccion" style={resultFormStyles.fieldLabel}>
                    Domicilio (calle, número, colonia, CP) *
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="direccion"
                    name="direccion"
                    defaultValue={location.state.person.address}
                    disabled={isDisabled}
                    required
                    style={getControlStyle(isDisabled)}
                  />
                </div>
              </ResultSectionBody>
            </ResultSection>

            <ResultSection className="no-print">
              <ResultSectionHeader statusName={statusName}>
                Información de la solicitud
              </ResultSectionHeader>
              <ResultSectionBody>
                <div
                  className="result-form-labeled-row"
                  style={resultFormStyles.labeledRow}
                >
                  <b style={resultFormStyles.labeledRowLabel}>Puesto *</b>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={location.state.vacancy?.position?.name}
                    disabled={isDisabled}
                    required
                    style={getControlStyle(isDisabled)}
                  />
                </div>
                {location.state?.applicationStatus?.name ===
                  "Entrevista con Lider" &&
                  !isLeaderView && (
                    <div
                      className="result-form-labeled-row"
                      style={resultFormStyles.labeledRow}
                    >
                      <b style={resultFormStyles.labeledRowLabel}>
                        Expectativa salarial al mes *
                      </b>
                      <input
                        type="number"
                        className="form-control"
                        id="expectativaSalarial"
                        name="expectativaSalarial"
                        defaultValue={location.state.monthlySalary}
                        disabled={isDisabled}
                        min="0"
                        required
                        style={getControlStyle(isDisabled)}
                      />
                    </div>
                  )}
                <div
                  className="result-form-labeled-row"
                  style={resultFormStyles.labeledRow}
                >
                  <b style={resultFormStyles.labeledRowLabel}>
                    Expectativa de permanencia *
                  </b>
                  <input
                    type="text"
                    className="form-control"
                    id="permanencia"
                    name="permanencia"
                    defaultValue={
                      location.state.stayingMonthsRange ||
                      (location.state.stayingMonths
                        ? `${location.state.stayingMonths} meses`
                        : "")
                    }
                    disabled={isDisabled}
                    required
                    style={getControlStyle(isDisabled)}
                  />
                </div>
                <div
                  className="result-form-labeled-row"
                  style={resultFormStyles.labeledRow}
                >
                  <b style={resultFormStyles.labeledRowLabel}>
                    Preferencia de turno *
                  </b>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={location.state.shift?.name}
                    disabled={isDisabled}
                    required
                    style={getControlStyle(isDisabled)}
                  />
                </div>
                <div
                  className="result-form-labeled-row"
                  style={resultFormStyles.labeledRow}
                >
                  <b style={resultFormStyles.labeledRowLabel}>
                    Preferencia de lugar
                  </b>
                  <input
                    type="text"
                    className="form-control"
                    value={
                      location.state.preferenciaLugarTipo ||
                      "Sin preferencia registrada"
                    }
                    disabled
                    style={getControlStyle(true)}
                  />
                </div>
                <div
                  className="result-form-labeled-row"
                  style={resultFormStyles.labeledRow}
                >
                  <b style={resultFormStyles.labeledRowLabel}>
                    Sucursal preferente
                  </b>
                  <input
                    type="text"
                    className="form-control"
                    value={
                      location.state.preferenciaSucursal?.name ||
                      "Sin sucursal o planta registrada"
                    }
                    disabled
                    style={getControlStyle(true)}
                  />
                </div>
                <div
                  className="result-form-labeled-row result-form-labeled-row-top"
                  style={{
                    ...resultFormStyles.labeledRow,
                    ...resultFormStyles.labeledRowTop,
                  }}
                >
                  <b style={resultFormStyles.labeledRowLabel}>Experiencia</b>
                  <textarea
                    className="form-control"
                    id="experiencia"
                    name="experiencia"
                    rows={4}
                    defaultValue={location.state.experience}
                    disabled={isDisabled}
                    required
                    style={{
                      ...getTextareaStyle(isDisabled),
                      minHeight: 120,
                    }}
                  />
                </div>
              </ResultSectionBody>
            </ResultSection>

            <ResultSection className="no-print">
              <ResultSectionHeader statusName={statusName}>
                Datos personales
              </ResultSectionHeader>
              <ResultSectionBody>
                <div
                  className="result-form-labeled-row"
                  style={resultFormStyles.labeledRow}
                >
                  <b style={resultFormStyles.labeledRowLabel}>Hijos</b>
                  <textarea
                    className="form-control result-form-input-like"
                    id="children"
                    name="children"
                    rows={1}
                    defaultValue={location.state.children}
                    disabled={isDisabled}
                    required
                    style={getTextareaStyle(isDisabled)}
                  />
                </div>
                <div
                  className="result-form-labeled-row result-form-labeled-row-top"
                  style={{
                    ...resultFormStyles.labeledRow,
                    ...resultFormStyles.labeledRowTop,
                  }}
                >
                  <b style={resultFormStyles.labeledRowLabel}>Estado de salud</b>
                  <textarea
                    className="form-control result-form-input-like"
                    id="health"
                    name="health"
                    rows={3}
                    defaultValue={location.state.health}
                    disabled={isDisabled}
                    required
                    style={getTextareaStyle(isDisabled)}
                  />
                </div>
                <div
                  className="result-form-labeled-row result-form-labeled-row-top"
                  style={{
                    ...resultFormStyles.labeledRow,
                    ...resultFormStyles.labeledRowTop,
                  }}
                >
                  <b style={resultFormStyles.labeledRowLabel}>
                    Enfermedades crónicas
                  </b>
                  <textarea
                    className="form-control result-form-input-like"
                    id="diseases"
                    name="diseases"
                    rows={3}
                    defaultValue={location.state.diseases}
                    disabled={isDisabled}
                    required
                    style={getTextareaStyle(isDisabled)}
                  />
                </div>
              </ResultSectionBody>
            </ResultSection>

            <ResultSection>
              <ResultSectionHeader statusName={statusName}>
                Documentación
              </ResultSectionHeader>
              <ResultSectionBody>
                <div
                  className="result-form-docs-grid"
                  style={resultFormStyles.docsGrid}
                >
                  <DocUploadSlot
                    label="Imagen de Perfil"
                    inputId="perfil-view"
                    previewUrl={perfilUrl}
                    onFileSelect={() => {}}
                    onPreview={openDocPreview}
                  />
                  <DocUploadSlot
                    label="Identificación Oficial Frente"
                    inputId="ine-view"
                    previewUrl={ineUrl}
                    onFileSelect={() => {}}
                    onPreview={openDocPreview}
                  />
                  <DocUploadSlot
                    label="Identificación Oficial Posterior"
                    inputId="ine1-view"
                    previewUrl={ine1Url}
                    onFileSelect={() => {}}
                    onPreview={openDocPreview}
                  />
                  <DocUploadSlot
                    label="Comprobante de domicilio"
                    inputId="domicilio-view"
                    previewUrl={domicilioUrl}
                    onFileSelect={() => {}}
                    onPreview={openDocPreview}
                  />
                  <DocUploadSlot
                    label="Solicitud de empleo"
                    inputId="solicitud-view"
                    previewUrl={solicitudUrl}
                    onFileSelect={() => {}}
                    onPreview={openDocPreview}
                  />
                </div>
              </ResultSectionBody>
            </ResultSection>
          </fieldset>
          {location.state.applicationStatus.name === "Pre-Colaborador" ||
          location.state.applicationStatus.name === "Entrevista con Lider" ? (
            <ResultSection>
              <ResultSectionHeader statusName={statusName}>
                Información del puesto
              </ResultSectionHeader>
              <ResultSectionBody>
                <div
                  className="result-form-fields-row"
                  style={resultFormStyles.fieldsGridRow}
                >
                  <div style={resultFormStyles.fieldBlock}>
                    <label
                      htmlFor="datepicker-autoClose"
                      style={resultFormStyles.fieldLabel}
                    >
                      Fecha de ingreso
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="datepicker-autoClose"
                      name="candidateRecruitmentDate"
                      defaultValue={candidate?.recruitmentDate}
                      required
                      disabled
                      style={disabledFieldStyle}
                    />
                  </div>
                  <div style={resultFormStyles.fieldBlock}>
                    <label htmlFor="position" style={resultFormStyles.fieldLabel}>
                      Puesto
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="position"
                      defaultValue={candidate?.vacancy?.position?.name}
                      required
                      disabled
                      style={disabledFieldStyle}
                    />
                  </div>
                  <div style={resultFormStyles.fieldBlock}>
                    <label
                      htmlFor="periodicity"
                      style={resultFormStyles.fieldLabel}
                    >
                      Periodicidad
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="periodicity"
                      defaultValue={candidate?.periodicity?.name}
                      required
                      disabled
                      style={disabledFieldStyle}
                    />
                  </div>
                </div>
                <div
                  className="result-form-fields-row"
                  style={resultFormStyles.fieldsGridRow}
                >
                  {location.state?.applicationStatus?.name ===
                    "Entrevista con Lider" &&
                    !isLeaderView && (
                      <div style={resultFormStyles.fieldBlock}>
                        <label htmlFor="salario" style={resultFormStyles.fieldLabel}>
                          Salario
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="salario"
                          defaultValue={candidate?.monthlySalary}
                          required
                          disabled
                          style={disabledFieldStyle}
                        />
                      </div>
                    )}
                  {location.state?.applicationStatus?.name ===
                    "Entrevista con Lider" &&
                    isLeaderView && (
                      <div style={resultFormStyles.fieldBlock}>
                        <span style={resultFormStyles.fieldLabel}>
                          Inicio de colaboración
                        </span>
                        <div
                          style={{
                            ...disabledFieldStyle,
                            height: "auto",
                            minHeight: 44,
                            padding: "10px 12px",
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            color: statusAccent,
                            fontWeight: 700,
                            background: `${statusAccent}14`,
                            border: `1px solid ${statusAccent}40`,
                          }}
                        >
                          <i className="fa fa-calendar-day" aria-hidden />
                          {(() => {
                            if (!candidate?.recruitmentDate)
                              return "Fecha de inicio no definida";
                            const start = moment(
                              candidate.recruitmentDate
                            ).startOf("day");
                            const today = moment().startOf("day");
                            const diff = start.diff(today, "days");
                            if (diff === 0) return "Empieza HOY";
                            if (diff < 0)
                              return `Empezó hace ${Math.abs(diff)} día(s)`;
                            return `Faltan ${diff} día(s) para que inicie a colaborador`;
                          })()}
                        </div>
                      </div>
                    )}
                  <div style={resultFormStyles.fieldBlock}>
                    <label htmlFor="sucursal" style={resultFormStyles.fieldLabel}>
                      Sucursal
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="sucursal"
                      defaultValue={candidate?.branch?.name}
                      required
                      disabled
                      style={disabledFieldStyle}
                    />
                  </div>
                  <div style={resultFormStyles.fieldBlock}>
                    <label htmlFor="turno" style={resultFormStyles.fieldLabel}>
                      Turno
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="turno"
                      defaultValue={candidate?.shift?.name}
                      required
                      disabled
                      style={disabledFieldStyle}
                    />
                  </div>
                </div>
                <div
                  className="result-form-fields-row"
                  style={{
                    ...resultFormStyles.fieldsGridRow,
                    gridTemplateColumns: "minmax(0, 1fr) minmax(0, 2fr)",
                  }}
                >
                  <div style={resultFormStyles.fieldBlock}>
                    <label htmlFor="talla" style={resultFormStyles.fieldLabel}>
                      Talla
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="talla"
                      defaultValue={candidate?.size?.name}
                      required
                      disabled
                      style={disabledFieldStyle}
                    />
                  </div>
                  <div style={resultFormStyles.fieldBlock}>
                    <label
                      htmlFor="comentarios"
                      style={resultFormStyles.fieldLabel}
                    >
                      Comentarios
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="comentarios"
                      defaultValue={candidate?.comments}
                      required
                      disabled
                      style={disabledFieldStyle}
                    />
                  </div>
                </div>
                <div style={{ ...resultFormStyles.fieldBlock, marginTop: 4 }}>
                  <span style={resultFormStyles.fieldLabel}>
                    Días que va a trabajar
                  </span>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 10,
                      marginTop: 6,
                    }}
                  >
                      {(() => {
                        const daysArray = candidate?.diasTrabajo
                          ? candidate.diasTrabajo
                              .split(",")
                              .map((d) => parseInt(d.trim()))
                              .filter((d) => !isNaN(d) && d >= 1 && d <= 7)
                          : [];
                        const getDayName = (dayNumber) => {
                          // Lunes=1, Martes=2, Miércoles=3, Jueves=4, Viernes=5, Sábado=6, Domingo=7
                          const days = [
                            "Lunes",
                            "Martes",
                            "Miércoles",
                            "Jueves",
                            "Viernes",
                            "Sábado",
                            "Domingo",
                          ];
                          return days[dayNumber - 1] || "";
                        };
                        return [1, 2, 3, 4, 5, 6, 7].map((dayNumber) => (
                          <button
                            key={dayNumber}
                            type="button"
                            disabled
                            style={getWorkDayChipStyle(
                              daysArray.includes(dayNumber),
                              statusName
                            )}
                            title={getDayName(dayNumber)}
                          >
                            {getDayName(dayNumber).substring(0, 3)}
                          </button>
                        ));
                      })()}
                  </div>
                </div>
                <div style={resultFormStyles.fieldBlock}>
                  <label
                    htmlFor="notasReclutador"
                    style={resultFormStyles.fieldLabel}
                  >
                    Notas del reclutador al candidato
                  </label>
                  <textarea
                    className="form-control"
                    id="notasReclutador"
                    name="notasReclutador"
                    defaultValue={candidate?.notasReclutador}
                    placeholder="Notas del reclutador al candidato"
                    rows={3}
                    disabled
                    style={getTextareaStyle(true)}
                  />
                </div>

                {candidate?.id && candidate?.vacancy?.position?.id && (
                  <div style={{ marginTop: 12 }}>
                    <CandidateDocumentsViewer
                      candidateId={candidate.id}
                      positionId={candidate.vacancy.position.id}
                    />
                  </div>
                )}
              </ResultSectionBody>
            </ResultSection>
          ) : (
            <ResultSection key={candidate?.id || "empty"}>
              <ResultSectionHeader statusName={statusName}>
                Información del puesto
              </ResultSectionHeader>
              <ResultSectionBody>
                <div
                  className="result-form-fields-row"
                  style={resultFormStyles.fieldsGridRow}
                >
                  <div style={resultFormStyles.fieldBlock}>
                    <label
                      htmlFor="datepicker-autoClose"
                      style={resultFormStyles.fieldLabel}
                    >
                      Fecha de ingreso
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="datepicker-autoClose"
                      name="candidateRecruitmentDate"
                      defaultValue={
                        location.state.candidate_recruitment_date ||
                        candidate?.recruitmentDate
                      }
                      required
                      style={enabledFieldStyle}
                    />
                  </div>
                  <div style={resultFormStyles.fieldBlock}>
                    <label htmlFor="candidateShift" style={resultFormStyles.fieldLabel}>
                      Turno
                    </label>
                    <select
                      className="form-select"
                      id="candidateShift"
                      name="candidateShift"
                      defaultValue={
                        location.state.candidate_id_shift ||
                        candidate?.shift?.id
                      }
                      onChange={(e) => {
                        setSelectedShiftIdForPosition(
                          e.target.value ? Number(e.target.value) : null
                        );
                      }}
                      required
                      style={enabledFieldStyle}
                    >
                      <option value="">Seleccione una opción</option>
                      {shifts.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div style={resultFormStyles.fieldBlock}>
                    <label
                      htmlFor="candidateBranch"
                      style={resultFormStyles.fieldLabel}
                    >
                      Sucursal
                    </label>
                    <select
                      className="form-select"
                      id="candidateBranch"
                      name="candidateBranch"
                      defaultValue={
                        location.state.candidate_id_branch ||
                        candidate?.branch?.id
                      }
                      onChange={(e) => {
                        setSelectedBranchIdForPosition(
                          e.target.value ? Number(e.target.value) : null
                        );
                      }}
                      required
                      style={enabledFieldStyle}
                    >
                      <option value="">Seleccione una opción</option>
                      {branches.map((item) => (
                        <option key={item.branch.id} value={item.branch.id}>
                          {item.branch.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div
                  className="result-form-fields-row"
                  style={resultFormStyles.fieldsGridRow}
                >
                  <div style={resultFormStyles.fieldBlock}>
                    <label
                      htmlFor="candidatePosition"
                      style={resultFormStyles.fieldLabel}
                    >
                      Puesto
                    </label>
                    <select
                      key={`puesto-${selectedBranchIdForPosition}-${selectedShiftIdForPosition}`}
                      className="form-select"
                      id="candidatePosition"
                      name="candidatePosition"
                      defaultValue={
                        location.state.candidate_id_position ||
                        candidate?.vacancy?.position?.id
                      }
                      onChange={handlePositionChange}
                      required
                      style={enabledFieldStyle}
                    >
                      <option value="">Seleccione una opción</option>
                      {positionsFilteredByBranchShift.map((item) => (
                        <option key={item.position.id} value={item.position.id}>
                          {item.position.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div style={resultFormStyles.fieldBlock}>
                    <label
                      htmlFor="candidatePeriodicity"
                      style={resultFormStyles.fieldLabel}
                    >
                      Periodicidad
                    </label>
                    <select
                      className="form-select"
                      id="candidatePeriodicity"
                      name="candidatePeriodicity"
                      defaultValue={
                        location.state.candidate_id_periodicity ||
                        candidate?.periodicity?.id
                      }
                      required
                      style={enabledFieldStyle}
                    >
                      <option value="">Seleccione una opción</option>
                      {periodicities.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div style={resultFormStyles.fieldBlock}>
                    <label
                      htmlFor="candidateMonthlySalary"
                      style={resultFormStyles.fieldLabel}
                    >
                      Salario
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="candidateMonthlySalary"
                      name="candidateMonthlySalary"
                      defaultValue={
                        location.state.candidate_monthly_salary ||
                        candidate?.monthlySalary
                      }
                      required
                      style={enabledFieldStyle}
                    />
                  </div>
                </div>
                <div
                  className="result-form-fields-row"
                  style={{
                    ...resultFormStyles.fieldsGridRow,
                    gridTemplateColumns: "minmax(0, 1fr) minmax(0, 2fr)",
                  }}
                >
                  <div style={resultFormStyles.fieldBlock}>
                    <label htmlFor="candidateSize" style={resultFormStyles.fieldLabel}>
                      Talla
                    </label>
                    <select
                      className="form-select"
                      id="candidateSize"
                      name="candidateSize"
                      defaultValue={
                        location.state.candidate_id_size || candidate?.size?.id
                      }
                      required
                      style={enabledFieldStyle}
                    >
                      <option value="">Seleccione una opción</option>
                      {sizes.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div style={resultFormStyles.fieldBlock}>
                    <label
                      htmlFor="candidateComments"
                      style={resultFormStyles.fieldLabel}
                    >
                      Comentarios
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="candidateComments"
                      name="candidateComments"
                      defaultValue={
                        location.state.candidate_comments ||
                        candidate?.comments
                      }
                      required
                      style={enabledFieldStyle}
                    />
                  </div>
                </div>
                <div style={{ ...resultFormStyles.fieldBlock, marginTop: 4 }}>
                  <span style={resultFormStyles.fieldLabel}>
                    Días que va a trabajar
                  </span>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 8,
                      marginTop: 8,
                      marginBottom: 10,
                    }}
                  >
                    <button
                      type="button"
                      className="btn btn-sm"
                      onClick={selectWeekdays}
                      style={{
                        border: `1px solid ${statusAccent}`,
                        color: statusAccent,
                        background: "#ffffff",
                        borderRadius: 999,
                        fontWeight: 600,
                      }}
                    >
                      <i className="fa fa-briefcase me-1" />
                      Lunes a Viernes
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm"
                      onClick={selectWeekend}
                      style={{
                        border: `1px solid ${statusAccent}99`,
                        color: statusAccent,
                        background: `${statusAccent}10`,
                        borderRadius: 999,
                        fontWeight: 600,
                      }}
                    >
                      <i className="fa fa-calendar-day me-1" />
                      Fines de Semana
                    </button>
                  </div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
                    {[1, 2, 3, 4, 5, 6, 7].map((dayNumber) => (
                      <button
                        key={dayNumber}
                        type="button"
                        onClick={() => toggleDay(dayNumber)}
                        style={{
                          ...getWorkDayChipStyle(
                            selectedDays.includes(dayNumber),
                            statusName
                          ),
                          cursor: "pointer",
                        }}
                        title={getDayName(dayNumber)}
                      >
                        {getDayName(dayNumber).substring(0, 3)}
                      </button>
                    ))}
                  </div>
                </div>
                <div style={resultFormStyles.fieldBlock}>
                  <label
                    htmlFor="candidateNotasReclutador"
                    style={resultFormStyles.fieldLabel}
                  >
                    Notas del reclutador al candidato
                  </label>
                  <textarea
                    className="form-control"
                    id="candidateNotasReclutador"
                    name="candidateNotasReclutador"
                    defaultValue={
                      location.state.candidate_notas_reclutador ||
                      candidate?.notasReclutador
                    }
                    placeholder="Notas del reclutador al candidato"
                    rows={3}
                    style={getTextareaStyle(false)}
                  />
                </div>

                {location.state?.applicationStatus?.name === "Aceptado" && (
                  <div className="row mt-4">
                    <ScheduleLeaderInterview
                      interviewCheck={interviewCheck}
                      setInterviewCheck={setInterviewCheck}
                      selectedLeader={selectedLeader}
                      setSelectedLeader={setSelectedLeader}
                      selectedDate={selectedDate}
                      setSelectedDate={setSelectedDate}
                      selectedSlot={selectedSlot}
                      setSelectedSlot={setSelectedSlot}
                    />
                  </div>
                )}

                {selectedPositionId && (
                  <>
                    <div className="row mt-4">
                      <div className="col-md-12">
                        <PositionUniformsInfo
                          positionId={selectedPositionId}
                          onTotalAmountChange={setUniformsTotalAmount}
                          hideIfEmpty={true}
                        />
                        {uniformsTotalAmount > 0 && (
                          <UniformPaymentForm
                            applicationId={location.state.id}
                            partnerId={undefined}
                            totalAmount={uniformsTotalAmount}
                            onPaymentChange={handleUniformPaymentChange}
                          />
                        )}
                      </div>
                    </div>
                    {!isLeaderView && (
                      <div className="row mt-4">
                        <div className="col-md-12">
                          <PositionDocumentsSelector
                            positionId={selectedPositionId}
                            onDocumentsChange={setSelectedDocuments}
                            selectedDocuments={selectedDocuments}
                            hideIfEmpty={true}
                          />
                          {selectedDocuments.length > 0 && (
                            <CandidateDocumentUploader
                              candidateId={candidate?.id || null}
                              positionId={selectedPositionId}
                              selectedDocuments={selectedDocuments}
                              applicationId={location.state.id}
                              isSaving={isSaving}
                              onFilesReady={(uploadFn) => {
                                uploadDocumentsRef.current = uploadFn;
                              }}
                            />
                          )}
                        </div>
                      </div>
                    )}
                  </>
                )}
              </ResultSectionBody>
            </ResultSection>
          )}

          {/* End of fieldset moved up to line 1169 */}

          {interviewData && (
            <Panel>
              <PanelHeader className="bg-azul" noButton={true}>
                Detalles de la Entrevista
              </PanelHeader>
              <PanelBody style={{ padding: "24px" }}>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                    gap: "24px",
                    background: "#ffffff",
                    borderRadius: "16px",
                    padding: "28px",
                    boxShadow:
                      "0 10px 15px -3px rgba(0, 0, 0, 0.05), 0 4px 6px -2px rgba(0, 0, 0, 0.02)",
                    border: "1px solid #eef2f6",
                  }}
                >
                  {/* Fecha */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <div
                      style={{
                        width: "54px",
                        height: "54px",
                        borderRadius: "14px",
                        background:
                          "linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#4338ca",
                        fontSize: "1.4rem",
                        boxShadow: "inset 0 2px 4px 0 rgba(0, 0, 0, 0.05)",
                      }}
                    >
                      <i className="fa fa-calendar-alt"></i>
                    </div>
                    <div>
                      <div
                        style={{
                          fontSize: "11px",
                          textTransform: "uppercase",
                          color: "#64748b",
                          fontWeight: "800",
                          letterSpacing: "1.2px",
                          marginBottom: "6px",
                        }}
                      >
                        Fecha Programada
                      </div>
                      <div
                        style={{
                          fontSize: "18px",
                          color: "#1e293b",
                          fontWeight: "700",
                        }}
                      >
                        {moment(interviewData.startTime).format("DD/MM/YYYY")}
                      </div>
                    </div>
                  </div>

                  {/* Hora */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <div
                      style={{
                        width: "54px",
                        height: "54px",
                        borderRadius: "14px",
                        background:
                          "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#b45309",
                        fontSize: "1.4rem",
                        boxShadow: "inset 0 2px 4px 0 rgba(0, 0, 0, 0.05)",
                      }}
                    >
                      <i className="fa fa-clock"></i>
                    </div>
                    <div>
                      <div
                        style={{
                          fontSize: "11px",
                          textTransform: "uppercase",
                          color: "#64748b",
                          fontWeight: "800",
                          letterSpacing: "1.2px",
                          marginBottom: "6px",
                        }}
                      >
                        Bloque Horario
                      </div>
                      <div
                        style={{
                          fontSize: "18px",
                          color: "#1e293b",
                          fontWeight: "700",
                        }}
                      >
                        {moment(interviewData.startTime).format("HH:mm")} -{" "}
                        {moment(interviewData.endTime).format("HH:mm")}
                      </div>
                    </div>
                  </div>

                  {/* Líder */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <div
                      style={{
                        width: "54px",
                        height: "54px",
                        borderRadius: "14px",
                        background:
                          "linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#15803d",
                        fontSize: "1.4rem",
                        boxShadow: "inset 0 2px 4px 0 rgba(0, 0, 0, 0.05)",
                      }}
                    >
                      <i className="fa fa-id-badge"></i>
                    </div>
                    <div>
                      <div
                        style={{
                          fontSize: "11px",
                          textTransform: "uppercase",
                          color: "#64748b",
                          fontWeight: "800",
                          letterSpacing: "1.2px",
                          marginBottom: "6px",
                        }}
                      >
                        Líder de Entrevista
                      </div>
                      <div
                        style={{
                          fontSize: "18px",
                          color: "#1e293b",
                          fontWeight: "700",
                        }}
                      >
                        {interviewData.leader?.name}{" "}
                        {interviewData.leader?.lastName}
                      </div>
                    </div>
                  </div>
                </div>

                {candidate?.leaderNotes && (
                  <div style={{ marginTop: "20px" }}>
                    <label
                      className="form-label fw-bold text-muted fs-12px uppercase mb-2"
                      style={{ letterSpacing: "1px" }}
                    >
                      Observaciones del Líder
                    </label>
                    <textarea
                      className="form-control bg-light"
                      rows={3}
                      value={candidate.leaderNotes}
                      readOnly
                      disabled
                      style={{
                        resize: "none",
                        fontSize: "14px",
                        border: "1px solid #dee2e6",
                      }}
                    />
                  </div>
                )}
              </PanelBody>
            </Panel>
          )}

          {isLeaderView && (
            <Panel>
              <PanelHeader className="bg-azul" noButton={true}>
                Notas del Líder de Sucursal
              </PanelHeader>
              <PanelBody>
                <div className="mb-3">
                  <textarea
                    className="form-control"
                    rows={4}
                    placeholder="Escriba aquí sus observaciones..."
                    value={leaderNotes}
                    onChange={(e) => setLeaderNotes(e.target.value)}
                    disabled={!!candidate?.leaderNotes || isSaving}
                  />
                </div>
              </PanelBody>
            </Panel>
          )}

          <div style={resultFormStyles.actionsCard}>
              <div className="row noGutters">
                <div
                  className="col-md-6"
                  style={{ display: "flex", justifyContent: "flex-start" }}
                >
                  {location.state.applicationStatus.name ===
                    "Pre-Colaborador" && !isLeaderView ? (
                    <a
                      onClick={handlePrint}
                      className="btn btn-secondary h-45px w-75 btn-lg fs-14px"
                    >
                      Generar orden de presentación
                    </a>
                  ) : (
                    <></>
                  )}
                </div>
                <div style={{ display: "none" }}>
                  <Print
                    id={location.state.id}
                    ref={componentRef}
                    name={toCamelCase(location.state.person.firstName)}
                    lastName={toCamelCase(location.state.person.lastName)}
                    secondLastName={toCamelCase(
                      location.state.person.secondLastName
                    )}
                    birthdate={location.state.person.birthdate}
                    phone={location.state.person.phone}
                    escolarity={location.state.person?.schooling?.name}
                    address={location.state.person.address}
                    photo={perfilUrl}
                    entryDate={candidate?.recruitmentDate}
                    position={candidate.vacancy?.position?.name}
                    periodicity={candidate?.periodicity?.name}
                    salary={candidate?.monthlySalary}
                    branch={candidate?.branch?.name}
                    shift={candidate?.shift?.name}
                    size={candidate?.size?.name}
                    comments={candidate?.comments}
                    children={location?.state?.children}
                    health={location?.state?.health}
                    diseases={location?.state?.diseases}
                  />
                </div>

                <div
                  className="col-md-6"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  {location.state?.applicationStatus?.name ===
                    "Pre-Colaborador" && !isLeaderView ? (
                    <button
                      type="button"
                      onClick={() => setShowModal(true)}
                      className="btn btn-amarillo h-45px w-75 btn-lg fs-14px"
                      disabled={isUpgrading}
                    >
                      {isUpgrading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Procesando...
                        </>
                      ) : (
                        "Aprobar"
                      )}
                    </button>
                  ) : (
                    <>
                      {isLeaderView && !candidate?.leaderNotes && (
                        <button
                          type="submit"
                          className="btn btn-amarillo h-45px w-75 btn-lg fs-14px"
                          disabled={isSaving || (leaderNotes?.length || 0) <= 5}
                        >
                          {isSaving ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Guardando...
                            </>
                          ) : location.state?.applicationStatus?.name ===
                              "Entrevista con Lider" && !isLeaderView ? (
                            "Guardar sin entrevista"
                          ) : (
                            "Guardar"
                          )}
                        </button>
                      )}
                      {!isLeaderView &&
                        location.state?.applicationStatus?.name !==
                          "Pre-Colaborador" && (
                          <button
                            type="submit"
                            className="btn btn-amarillo h-45px w-75 btn-lg fs-14px"
                            disabled={isSaving}
                          >
                            {isSaving ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                Guardando...
                              </>
                            ) : location.state?.applicationStatus?.name ===
                              "Entrevista con Lider" ? (
                              "Guardar sin entrevista"
                            ) : (
                              "Guardar"
                            )}
                          </button>
                        )}
                      {location.state?.applicationStatus?.name ===
                        "Pre-Colaborador" && (
                        <div className="bg-azul text-white fs-14px w-75 btn-lg h-45px fw-bold text-center d-flex align-items-center justify-content-center rounded">
                          YA ENTREVISTADO
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
          </div>
        </form>
      </div>
      <ModalContainer
        open={docPreviewModal.open}
        closeFn={() =>
          setDocPreviewModal({ open: false, title: "", src: "" })
        }
        title={docPreviewModal.title}
        size="lg"
      >
        <div style={{ textAlign: "center", padding: "8px 0" }}>
          <img
            src={docPreviewModal.src}
            alt={docPreviewModal.title}
            style={{
              maxWidth: "100%",
              maxHeight: "70vh",
              objectFit: "contain",
              borderRadius: 8,
            }}
          />
        </div>
      </ModalContainer>
      <ModalContainer
        open={showModal}
        closeFn={() => setShowModal(false)}
        title={`Hacer colaborador a ${toCamelCase(
          location.state.person?.firstName +
            " " +
            location.state.person?.lastName
        )}`}
        children={
          <UpgradeToCollaborator
            id={location.state.person.id}
            name={`${toCamelCase(
              location.state.person?.firstName +
                " " +
                location.state.person?.lastName
            )}`}
            func={() => handleClick()}
            closeFn={() => setShowModal(false)}
            isLoading={isUpgrading}
          />
        }
      />
      <div
        className="w-1000px h-75px"
        style={{
          backgroundImage: "url(../../../assets/img/footer/footer-chili.png)",
          backgroundRepeat: "repeat-x",
          position: "fixed",
          bottom: "0",
          left: "0",
          width: "100%",
          zIndex: 1,
        }}
      />
    </div>
  );
}

export default FormPostulante;
